








import { Component, Vue } from 'vue-property-decorator';  
import Banner from '@/components/Loja/Banner.vue'
import Produtos from '@/components/Loja/Produtos.vue'

@Component({
  components: {
      Banner, Produtos
  },
})
export default class Loja extends Vue {}
